import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { SeasonalRule } from 'models/seasonality/SeasonalRule';

const AppliesToCell = ({ row }: { row: Row<SeasonalRule> }) => {
  const { t } = useTranslation();
  const { metadata } = row.original;

  if (metadata?.appliesToAllProperties) {
    return t('pageProperty.common.cells.allProperties');
  }

  const properties = metadata?.propertiesThatAppliesTo ?? [];

  if (properties.length === 1) {
    return properties[0].name;
  }

  return t('pageProperty.common.cells.amountProperties', {
    count: properties.length,
  });
};

export default AppliesToCell;
